import React, { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useNavigate } from "react-router-dom";
import AWSManagerSingleton from "../../Utility/AWS/AWSManagerSingleton";
import dbManagerInterface from "../../Utility/DbConnection/DBManagerInterface";
import { $Command } from "@aws-sdk/client-cognito-identity-provider";

const ClientPlantChoicePage = () => {
  const [company, setCompany] = useState("");
  const [availableClients, setAvailableClients] = useState([]);
  const [availablePlants, setAvailablePlants] = useState([]);
  const [availableMachines, setAvailableMachines] = useState([]);

  const [chosenClient, setChosenClient] = useState("");
  const [chosenPlant, setChosenPlant] = useState("");
  const [filteredMachines, setFilteredMachines] = useState([]);

  const navigate = useNavigate();
  const awsManagerSingleton = new AWSManagerSingleton();

  useEffect(() => {
    fetchUserAttributes();
  }, []);

  const parseMachineList = (machineListRaw) => {
    try {
      // Example: "{[Automata;Automata;0001];[Ergos;Caronno;Termoformatrice]}"
      const cleanStr = machineListRaw.replace(/[{}]/g, "");
      const groups = cleanStr
        .split("];[")
        .map((g) => g.replace(/\[|\]/g, "").split(";"));
      // Format => [{client, plant, machine}]
      return groups.map(([client, plant, machine]) => ({
        client,
        plant,
        machine,
      }));
    } catch (err) {
      console.error("Error parsing machine list:", err);
      return [];
    }
  };

  const fetchUserAttributes = async () => {
    try {
      const attributes =
        await awsManagerSingleton.CognitoGetLoggedUserAttributes();
      console.log("User attributes:", attributes);

      setCompany(attributes["custom:company"]);

      const machines = parseMachineList(attributes["custom:machineList"]);
      setAvailableMachines(machines);
      setAvailablePlants([...new Set(machines.map((m) => m.plant))]);
      setAvailableClients([...new Set(machines.map((m) => m.client))]);
    } catch (error) {
      console.error("Error fetching user attributes:", error);
    }
  };

  const handleConfirm = () => {
    //save in session storage the chosen client and plant
    sessionStorage.setItem("chosenClient", chosenClient);
    sessionStorage.setItem("chosenPlant", chosenPlant);

    //now for this client and plant i need to get the available store types
    const apiName = "Automata/GetStoreTypes";
    const queryParams = `Client=${chosenClient}-${chosenPlant}`;
    dbManagerInterface.SendGetRequest(
      apiName,
      (resData) => {
        if (resData.success && resData.data?.length > 0) {
          console.log("Store types:", resData.data);
          const storeTypes = resData.data;
          sessionStorage.setItem(
            "availableStoreTypes",
            JSON.stringify(storeTypes)
          );
          if (storeTypes.includes("STORE_ENDPROCESS")) {
            navigate("/endprocess");
          } else if (storeTypes.includes("STORE_GRAPH")) {
            navigate("/curves");
          } else if (storeTypes.includes("STORE_ALARMS")) {
            navigate("/alarms");
          } else if (storeTypes.includes("STORE_REALTIME")) {
            navigate("/continousdata");
          } else if (storeTypes.includes("STORE_EVENT")) {
            navigate("/events");
          } else if (storeTypes.includes("STORE_RUNNING")) {
            navigate("/running");
          } else {
            alert("No store types available for the selected client and plant");
          }
        } else {
          sessionStorage.setItem("availableStoreTypes", JSON.stringify([]));
          alert("No store types available for the selected client and plant");
        }
      },
      (error) => {
        console.error("Error fetching store types:", error);
        sessionStorage.setItem("availableStoreTypes", JSON.stringify([]));
        alert("Error fetching store types for the selected client and plant");
      },
      null,
      null,
      queryParams
    );

    //navigate("/endprocess");
  };

  useEffect(() => {
    if (chosenPlant && chosenClient) {
      const filtered = availableMachines.filter(
        (m) => m.plant === chosenPlant && m.client === chosenClient
      );
      setFilteredMachines(filtered);
    } else {
      setFilteredMachines([]);
    }
  }, [chosenClient, chosenPlant, availableMachines]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        background: "rgba(227, 30, 36, 0.9)",
        padding: "20px",
      }}
    >
      <img
        src="/pms/cannonOrizzontaleBianco.png"
        alt="Cannon"
        style={{ width: "25rem" }}
      />
      <Card
        style={{
          width: "100%",
          maxWidth: "800px",
          padding: "2rem",
          borderRadius: "1rem",
          boxShadow: "0 8px 24px rgba(227, 30, 36, 0.3)",
          background: "#fff",
          textAlign: "center",
        }}
      >
        <h2 style={{ marginBottom: "1.5rem" }}>Client Plant Selection</h2>

        {/* Company */}
        <div className="p-field" style={{ marginBottom: "1rem" }}>
          <label htmlFor="company">Company</label>
          <InputText
            id="company"
            value={company}
            disabled
            style={{ width: "100%" }}
          />
        </div>

        {/* Client Dropdown */}
        <div className="p-field" style={{ marginBottom: "1rem" }}>
          <label htmlFor="client">Client</label>
          <Dropdown
            id="client"
            value={chosenClient}
            options={availableClients.map((p) => ({ label: p, value: p }))}
            onChange={(e) => {
              // filter available plants based on chosen client
              const plantsForClient = availableMachines
                .filter((m) => m.client === e.value)
                .map((m) => m.plant);
              setAvailablePlants([...new Set(plantsForClient)]);
              setChosenPlant(""); // reset chosen plant
              setChosenClient(e.value);
            }}
            placeholder="Select a Client"
            style={{ width: "100%" }}
          />
        </div>

        {/* Plant Dropdown */}
        <div className="p-field" style={{ marginBottom: "1rem" }}>
          <label htmlFor="plant">Plant</label>
          <Dropdown
            id="plant"
            disabled={!chosenClient}
            value={chosenPlant}
            options={availablePlants.map((p) => ({ label: p, value: p }))}
            onChange={(e) => setChosenPlant(e.value)}
            placeholder="Select a Plant"
            style={{ width: "100%" }}
          />
        </div>

        {/* Machines DataTable */}
        {chosenPlant && chosenClient && (
          <div style={{ marginTop: "2rem" }}>
            <h3>
              Machines in Plant "{chosenClient}" - "{chosenPlant}"
            </h3>
            <DataTable
              value={filteredMachines}
              paginator
              rows={5}
              stripedRows
              style={{ marginTop: "1rem" }}
            >
              <Column field="client" header="Client" sortable />
              <Column field="plant" header="Plant" sortable />
              <Column field="machine" header="Machine" sortable />
            </DataTable>
          </div>
        )}

        {/* Confirm Button */}
        <Button
          label="Confirm"
          onClick={handleConfirm}
          disabled={!chosenPlant}
          style={{
            marginTop: "2rem",
            width: "100%",
            padding: "0.75rem",
            background: "#E31E24",
            border: "none",
            borderRadius: "0.5rem",
            color: "#fff",
            fontWeight: "bold",
            transition: "background 0.3s",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.background = "#C2181C")}
          onMouseLeave={(e) => (e.currentTarget.style.background = "#E31E24")}
        />
      </Card>
    </div>
  );
};

export default ClientPlantChoicePage;
